import { type ChatMessage, type AgentPhase } from "../hooks/useSpaceAgent";
import SpaceAgentChat from "./SpaceAgentChat";
import "../space-live.css";

type Props = {
  messages: ChatMessage[];
  agentPhase: AgentPhase;
  isRecording: boolean;
  sendMessage: (text: string) => void;
  isOpen: boolean;
};

export default function SpaceAgentOverlay({
  messages,
  agentPhase,
  isRecording,
  sendMessage,
  isOpen,
}: Props) {
  return (
    <div
      className="et-live-chrome absolute inset-0 rounded-[11px] flex flex-col transition-opacity duration-200"
      style={{
        zIndex: 300,
        opacity: isOpen ? 1 : 0,
        pointerEvents: isOpen ? "auto" : "none",
        background: "var(--et-paper)",
      }}
    >
      <SpaceAgentChat
        messages={messages}
        agentPhase={agentPhase}
        isRecording={isRecording}
        sendMessage={sendMessage}
      />
    </div>
  );
}
